import styled from 'styled-components';
export const Wrapper = styled.div `
  //display: flex;
  //flex-direction: column;
  //align-items: center;
  height: 100%;
`;
export default {
    Wrapper,
};
